import { render, staticRenderFns } from "./EmailSendingHistory.vue?vue&type=template&id=fa090b2c&scoped=true&"
import script from "./EmailSendingHistory.vue?vue&type=script&lang=js&"
export * from "./EmailSendingHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa090b2c",
  null
  
)

export default component.exports